export default "__VITE_ASSET__BXvA6ev9__"